import React, { useState } from "react";
//import Input from "react-select/dist/declarations/src/components/Input";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { changeDefaultColor, changeDefaultNumber, changeDefaultImage, changeDefaultAnchor, } from "../../../../store/tool";
import ColorInput from "../../../Palettes/Propertybar/input/colorInput";
import NumberInput from "../../../Palettes/Propertybar/input/numberInput";
import { SymbolLibraryManager, SymbolLibraryManagerMode } from "../../modals/SymbolLibraryManager/SymbolLibraryManager";
import { GlobalImageRepository } from "../GlobalImageRepository";

const SymbolDefaultProperyPalette = ({ symbol }: { symbol: GeometricShape }) => {
  const dispatch = useAppDispatch();
  const definitionStrokeColor = useAppSelector(state => state.tool.toolSettings.symbol.current.stroke)
  const definitionLineWeight = useAppSelector(state => state.tool.toolSettings.symbol.current.strokeWidth)
  const definitionAnchor = useAppSelector(state => state.tool.toolSettings.symbol.current.anchor)

  const [libMode, setLibMode] = useState<SymbolLibraryManagerMode>("pick");
  const [showModal, setShowModal] = useState(false);
  const [selectedKey, setSelectedKey] = useState<string>("");

  const handlePick = (id: string, image: HTMLImageElement) => {
    setSelectedKey(id);
    if (id) {
      const actionPayload = {
        id: "symbol",
        propertyValue: id,
        propertyName: "imageKey",
      };
      dispatch(changeDefaultImage(actionPayload));
    }
  };

  const setAnchor = (v:VerticalAnchor, h:HorizontalAnchor) => {
    const payload = {
      id: "symbol",
      propertyValue: {
        horizontal: h,
        vertical: v,
    },
      propertyName: "anchor",
    };
    dispatch(changeDefaultAnchor(payload));
  }

  return (
    <>
      <div className="property__element">
        <ColorInput
          properyDisplayName={"Stroke color"}
          currentValue={definitionStrokeColor as ColorValue}
          setValue={(input: ColorValue) => {
            console.log(input);

            const actionPayload = {
              id: "symbol",
              propertyValue: input,
              propertyName: "stroke",
            };
            dispatch(changeDefaultColor(actionPayload));
          }}
        />
      </div>
      <div className="property__element">
        <div className="flex flex-col">
          {selectedKey &&
          <>
            <img src={GlobalImageRepository.getImage(selectedKey)?.src} alt="dynamic stuff" />
          </>}
        </div>
      </div>
      <div>
      <button onClick={() => { setLibMode("edit"); setShowModal(true); }}>Edit Images</button>
      <button onClick={() => { setLibMode("pick"); setShowModal(true); }}>Pick Image</button>

      </div>
      <div className="property__element">
        <div style={{display: "grid", gridTemplateRows: "30px 30px 30px", gridTemplateColumns: "30px 30px 30px"}}>
          <div style={{backgroundColor: (definitionAnchor.vertical === "top" && definitionAnchor.horizontal === "left") ? "green" : "white"}}><button onClick={() => setAnchor("top", "left")}>TL</button></div>
          <div style={{backgroundColor: (definitionAnchor.vertical === "top" && definitionAnchor.horizontal === "center") ? "green" : "white"}}><button onClick={() => setAnchor("top", "center")}>TC</button></div>
          <div style={{backgroundColor: (definitionAnchor.vertical === "top" && definitionAnchor.horizontal === "right") ? "green" : "white"}}><button onClick={() => setAnchor("top", "right")}>TR</button></div>
          <div style={{backgroundColor: (definitionAnchor.vertical === "center" && definitionAnchor.horizontal === "left") ? "green" : "white"}}><button onClick={() => setAnchor("center", "left")}>CL</button></div>
          <div style={{backgroundColor: (definitionAnchor.vertical === "center" && definitionAnchor.horizontal === "center") ? "green" : "white"}}><button onClick={() => setAnchor("center", "center")}>CC</button></div>
          <div style={{backgroundColor: (definitionAnchor.vertical === "center" && definitionAnchor.horizontal === "right") ? "green" : "white"}}><button onClick={() => setAnchor("center", "right")}>CR</button></div>
          <div style={{backgroundColor: (definitionAnchor.vertical === "bottom" && definitionAnchor.horizontal === "left") ? "green" : "white"}}><button onClick={() => setAnchor("bottom", "left")}>BL</button></div>
          <div style={{backgroundColor: (definitionAnchor.vertical === "bottom" && definitionAnchor.horizontal === "center") ? "green" : "white"}}><button onClick={() => setAnchor("bottom", "center")}>BC</button></div>
          <div style={{backgroundColor: (definitionAnchor.vertical === "bottom" && definitionAnchor.horizontal === "right") ? "green" : "white"}}><button onClick={() => setAnchor("bottom", "right")}>BR</button></div>
        </div>
      </div>
      <div className="property__element">
        <NumberInput
          propertyDisplayName="Line weight"
          currentValue={definitionLineWeight ?? 1}
          setValue={(number) => {
            const payload = {
              id: "symbol",
              propertyValue: number,
              propertyName: "strokeWidth",
            };
            dispatch(changeDefaultNumber(payload));
          }}
        ></NumberInput>
      </div>

      {showModal && (
      <SymbolLibraryManager
          initialImages={GlobalImageRepository.exportAsBase64Map()}
          mode={libMode}
          onClose={() => setShowModal(false)}
          onPick={handlePick}
      />
      )}
    </>)
};
const createDefaultPropertyPalette = (symbol: GeometricShape) => {
  return <SymbolDefaultProperyPalette symbol={symbol} />;
};
export default createDefaultPropertyPalette;
